import React from 'react';
import { ProgressCircular } from '@mtnkente/paragon-indicators/progress-circular';
import { Dialog } from '@mtnkente/paragon-overlays/dialog';
import { LoadingOverlay, LoadingFrame, ModalOverlay, DialogContainer } from './Loader.style';
import { ComboButtons } from '@mtnkente/paragon-buttons/combo-buttons';
import { StandardButton } from '@mtnkente/paragon-buttons/standard-button';
import { Text } from '@mtnkente/paragon-display/text';
import { useTranslation } from 'react-i18next';

interface LoaderProps {
  isLoading?: boolean;
  error?: boolean;
  message?: string;
  isReady?: boolean;
  handleRefreshClick?: () => void;
  handleHomeClick?: () => void;
}

const Loader: React.FC<LoaderProps> = ({
  isLoading,
  error,
  isReady,
  message,
  handleRefreshClick,
  handleHomeClick,
}) => {
  const { t } = useTranslation();
  return (
    <>
      {isLoading ? (
        <LoadingOverlay data-testid='loader'>
          <LoadingFrame>
            <ProgressCircular size={'large'} $variant={'brand'} />
            <Text $colour={'full'} $fontStyle={'title-small-bold'}>
              {!isReady ? '' : (message ?? t('just-moment'))}
            </Text>
          </LoadingFrame>
        </LoadingOverlay>
      ) : error ? (
        <ModalOverlay $intensity={'medium'} isVisible $isInverted={false} $isBackgroundBlur={true}>
          <DialogContainer data-testid='error-modal'>
            <Dialog title={t('something-went-wrong')} description={t('try-reload-page-homepage')}>
              <ComboButtons $isStacked={true}>
                <StandardButton
                  label={t('refresh')}
                  $variant={'primary'}
                  onClick={handleRefreshClick}
                  data-testid='refresh-button'
                />
                <StandardButton
                  label={t('home')}
                  $variant={'secondary'}
                  onClick={handleHomeClick}
                  data-testid='home-button'
                />
              </ComboButtons>
            </Dialog>
          </DialogContainer>
        </ModalOverlay>
      ) : (
        <></>
      )}
    </>
  );
};

export default Loader;

Loader.displayName = 'Loader';
